import { EMPTY_ESTIMATED_UNBILL_FIGURE_MODEL } from "presentation/model/EstimatedUnbillFigure/EstimatedUnbillFigureModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: EstimatedUnbillFigureProvider,
    useTracked: useEstimatedUnbillFigureTracked
} = createContainer(() => useState(EMPTY_ESTIMATED_UNBILL_FIGURE_MODEL), { concurrentMode: true });
export { EstimatedUnbillFigureProvider, useEstimatedUnbillFigureTracked };

